"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodPactAbilityHandler = exports.BloodPactActorAbilityFactory = exports.BloodPactAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Damage_1 = require("../../core/Damage");
const Duration_1 = require("../../core/Duration");
const Bleeding_1 = require("../../core/effects/core/Bleeding");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class BloodPactAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BloodPact;
        this.__typeName = "BloodPact";
    }
}
exports.BloodPactAbilityArgs = BloodPactAbilityArgs;
let BloodPactActorAbilityFactory = class BloodPactActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BloodPact", "OneEnemies", 2);
    }
};
BloodPactActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BloodPact")
], BloodPactActorAbilityFactory);
exports.BloodPactActorAbilityFactory = BloodPactActorAbilityFactory;
let BloodPactAbilityHandler = class BloodPactAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 60)
            ],
            onHit(sequence, _attack, damages) {
                const totalDamage = Damage_1.Damage.Sum(damages);
                const amount = Math.round(totalDamage);
                container.applyHealing({
                    sequence,
                    animate: false,
                    healerId: ability.invokerId,
                    targetId: ability.invokerId,
                    amount: amount
                });
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new Bleeding_1.BleedingEffectArgs("Power", 10)
                });
                if (container.hasAttribute(ability.invokerId, "Charm_Vampire_0")) {
                    container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                        .forEach(targetId => container.applyHealing({
                        healerId: ability.invokerId,
                        targetId,
                        sequence,
                        amount: Math.ceil(amount * .5),
                        onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "PulsingBlood"))
                    }));
                }
            }
        });
    }
};
BloodPactAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BloodPact)
], BloodPactAbilityHandler);
exports.BloodPactAbilityHandler = BloodPactAbilityHandler;
